import { createContext, useCallback, useContext, useLayoutEffect, useState } from "react";

const STORAGE_KEY = "atrium-theme";
const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [darkmode, setDarkmodeState] = useState(
    () => localStorage.getItem(STORAGE_KEY) === "dark"
  );

  useLayoutEffect(() => {
    document.body.classList.toggle("dark", darkmode);
  }, [darkmode]);

  const setDarkmode = useCallback((enabled) => {
    localStorage.setItem(STORAGE_KEY, enabled ? "dark" : "light");
    setDarkmodeState(enabled);
  }, []);

  return <ThemeContext.Provider value={{ darkmode, setDarkmode }}>{children}</ThemeContext.Provider>;
};

export const useDarkmode = () => {
  return useContext(ThemeContext);
};
